'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './contact-edit.routes';

export class ContactEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, ContactService, SettingsService, $uibModal, $window) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.contactId = $stateParams.id;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.ContactService = ContactService;
    this.SettingsService = SettingsService;
    this.Auth = Auth;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("contact")) {
        this.customSchema = customFieldSettings.data.contact;
        this.customForm = ["*"];
      }
    });

    this.jsonValue = "";
    this.$state = $state;

    this.SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.phoneTypes = appSettings.data.phoneTypes;
      this.mailTypes = appSettings.data.mailTypes;
      this.addressTypes = appSettings.data.addressTypes;
      this.socialTypes = appSettings.data.socialTypes;
    });

    this.model = {
      phone: [],
      email: [],
      web: [],
      address: [],
      customFields: {}
    };

    this.customFields = {};

    if (this.contactId) {
      this.ContactService.get({id: this.contactId}, data => {
        this.model = data;
        if (!this.model.address)
          this.model.address = [];

        this.customFields = this.model.customFields || {};
      }, err => {
        console.log('Could not load contact data from server');
      })
    }
  }

  addressEdit(idx, address) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addressEdit',
      resolve: {
        config: function() {
          return {
            data: address
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (address) {

        that.model.address[idx] = address;

      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.codeId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The contact has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("contact-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.customFields = this.customFields || {};

      if (this.contactId) {  // Save changes on the current settings
        this.ContactService.update({id: this.contactId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.ContactService.save(this.model, onSuccess, onError);
      }
    }
  }

  updatePrimaryPhone(idx) {
    angular.forEach(this.model.phone, (phone, index) => {
      phone.isPrimary = (idx == index);
    });
  }

  addPhone() {
    this.model.phone.push({
      type: this.phoneTypes[0],
      number: '',
      isPrimary: !this.model.phone.length
    })
  }

  removePhone(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.model.phone[idx].isPrimary;

    // remove the phone
    this.model.phone.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.phone.length > 0) {
      this.model.phone[0].isPrimary = true;
    }
  }

  addSocial() {
    this.model.web.push({
      type: this.socialTypes[0],
      link: ''
    })
  }

  removeSocial(idx) {
    // remove the phone
    this.model.web.splice(idx,1);

  }

  updatePrimaryEmail(idx) {
    angular.forEach(this.model.email, (email, index) => {
      email.isPrimary = (idx == index);
    });
  }

  addEmail() {
    this.model.email.push({
      type: this.mailTypes[0],
      address: '',
      isPrimary: !this.model.email.length
    })
  }

  removeEmail(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.model.email[idx].isPrimary;

    // remove the phone
    this.model.email.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.email.length > 0) {
      this.model.email[0].isPrimary = true;
    }
  }

  updatePrimaryAddress(idx) {
    angular.forEach(this.model.address, (address, index) => {
      address.isPrimary = (idx == index);
    });
  }

  updateMailingAddress(idx) {
    if (this.model.address[idx].isMailing) {
      // only allow one to be checked
      angular.forEach(this.model.address, (address, index) => {
        address.isMailing = (idx == index);
      });
    } else {
      //uncheck
      //console.log("uncheck", idx, this.model.address[idx].isMailing);
      this.model.address[idx].isMailing = false;
    }
  }

  addAddress() {
    let idx = this.model.address.length;
    this.addressEdit(idx, {
      type: this.phoneTypes[0],
      state: 'FL',
      isPrimary: !idx
    });
  }

  removeAddress(idx) {
    // Check if the removed address was the primary one
    let primaryRemoved = this.model.address[idx].isPrimary;

    // remove the address
    this.model.address.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.address.length > 0) {
      this.model.address[0].isPrimary = true;
    }
  }
}

export default angular.module('conduu.contactEdit', [uiRouter])
  .config(routes)
  .component('contactEdit', {
    template: require('./contact-edit.html'),
    controller: ContactEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-edit/contact-edit.component.js